import React from 'react';
import { useDispatch } from 'react-redux';
import PlainButton from '../../../../Controls/plainButton'
import './Dashboard.css';
import { getImage } from '../../../../../utils/ImageUtil';
import T from 'i18n-react';
import { push } from 'connected-react-router';
import { trackEvent, HeapEvents } from '../../../../../utils/AnalyticsUtil';
import classNames from 'classnames';

const CreateNewReturnSection = ({ layoutType }) => {
    const dispatch = useDispatch();
    const onStartNewReturn = () => {
        trackEvent(HeapEvents.BUTTON_START_NEWCLIENT_TAXYEAR);
        dispatch(push('/dashboard/interview/year_selection'));
    }

    return (
        <div className={classNames('wf-wp-createNewReturn-wrapper-container', layoutType)}>
            <div className={classNames('wf-wp-createNewReturn-img', layoutType)}>
                <img src={getImage(layoutType === 'mobile' ? 'lets-get-started-mobile' : 'lets-get-started')} alt='Lets Get Started' />  
            </div>
            <div className={classNames('wf-wp-createNewReturn-container', layoutType)}>
                <div>
                    <div className='wf-wp-createNewReturn-header'>
                        {T.translate('WorkflowPanel.letsGetStartedHeader')}
                    </div>
                    <div className={classNames('wf-wp-createNewReturn-text', layoutType)}>
                        {T.translate('WorkflowPanel.letsGetStartedDesc')}
                    </div>
                </div>
                <div className={classNames('wf-wp-createNewReturn-button-container', layoutType)}>
                    <PlainButton labelKey='WorkflowPanel.createNewReturn' onClick={onStartNewReturn} inProgress={false} />
                </div>
            </div>
        </div>
    )
};

export default CreateNewReturnSection;